import { Dialog } from 'vant';
import { WX_NOT_SUBSCRIBED_MESSAGE } from '@/utils/wechatAuth';

let noticePromise = null;

// 只有明确未关注公众号时才提示；其他授权异常由原流程静默结束。
export function showWxAuthNotice(error) {
  if (!error || error.message !== WX_NOT_SUBSCRIBED_MESSAGE) return Promise.resolve();
  // 多个接口或路由同时报错时复用当前弹窗，不能叠加或反复覆盖提示。
  if (noticePromise) return noticePromise;
  noticePromise = Dialog.alert({
    title: '登录提示',
    message: WX_NOT_SUBSCRIBED_MESSAGE,
    confirmButtonText: '我知道了',
    allowHtml: false,
    closeOnClickOverlay: false,
    closeOnPopstate: false,
  })
    .catch(() => {
      // 弹窗被外部关闭时也正常收尾，不向路由或接口链抛出未处理异常。
    })
    .then(() => {
      noticePromise = null;
    });
  return noticePromise;
}
